import { cache } from '@/utils';
import ScriptSnippets from '@/components/Layout/ScriptSnippets';
import { GDPRCountry, getCookieConsent } from './CookieConsent.config';
import { GlobalTracker } from '@/utils/Tracker';

// const CookieBannerId = 'CookieConsentBanner';
// const CookieDetailId = 'CookieConsentDetail';

// Cookie同意分类
const Category = {
  preferences: 'preferences',
  statistics: 'statistics',
  marketing: 'marketing',
};

/**
 *
 * @description 集成CookieBot进行Cookie合规管理
 *
 *              - 若用户未授权，则使用以CookieBot解析地区为准，
 *              - 若用户已授权[Cookiebot.userCountry]，且授权地区与当前访问地区一致，则以授权为准
 *              - 若用户已授权且当前访问地区不一致时，以商城当前地区为准
 *
 * @date 2023/07/16 17:21:40
 * @author haifn
 * @param {Object} Cookiebot 实例
 * @param {Object} country 当前站点国家地区
 * @param {Object} Cookiebot 实例
 * @return
 */
class CookieConsent {
  constructor(props) {
    const { Cookiebot, DetailModalRef, CookieBannerRef, DNSModalRef } = props;
    if (CookieConsent.instance) {
      return CookieConsent.instance;
    } else {
      this.props = props;
      this.InstaCountry = window.country ?? {};
      this.Category = Category;
      // CookieSetting弹窗实例
      this.DetailModalRef = DetailModalRef;
      // CookieBanner实例
      this.CookieBannerRef = CookieBannerRef;
      // DoNotSell弹窗实例
      this.DNSModalRef = DNSModalRef;
      // Cookiebot实例
      this.Cookiebot = Cookiebot ?? {};
      // 自定义授权标记， 获取不到Cookiebot则使用自定义
      this.customAuth = !Cookiebot;
      // 授权有效期（需要和cookiebot后台设置同步）
      this.CookieExpires = 180;
      // 非必要服务分类
      this.SnippetsGroup = this.initSnippets();

      this.init();

      CookieConsent.instance = this;
      window.CookieConsentInstance = this;
    }
  }

  init() {
    this.initAuth();

    this.initAuthCountry();

    this.initConsent();

    this.handleAcceptListener();
  }

  initAuth() {
    const { CookieBotAuth, CookieInsAuth } = getCookieConsent();
    this.CookieBotAuth = CookieBotAuth;
    this.CookieInsAuth = CookieInsAuth;
  }

  initAuthCountry() {
    const { Cookiebot, InstaCountry, CookieBotAuth } = this;
    const cookieBotCountryCode = Cookiebot?.userCountry?.toUpperCase();
    const instaCountryCode = InstaCountry?.code?.toUpperCase();

    let code = instaCountryCode;

    if (cookieBotCountryCode) {
      if (CookieBotAuth) {
        code = cookieBotCountryCode === instaCountryCode ? cookieBotCountryCode : instaCountryCode;
      } else {
        code = cookieBotCountryCode;
      }
    }

    const isGDPR = GDPRCountry.includes(code);
    const isUS = code.indexOf('US') >= 0;
    const isOthers = !isGDPR && !isUS;

    this.CookieCountry = {
      isGDPR,
      isUS,
      isOthers,
      code,
      cookieBotCountryCode,
      instaCountryCode,
    };

    this.complyGPC = isGDPR || isUS || GDPRCountry.includes(InstaCountry?.code) || InstaCountry?.code === 'US';
  }

  initConsent() {
    const { CookieBotAuth, CookieInsAuth } = this;

    this.consent = {
      preferences: false,
      statistics: false,
      marketing: false,
    };

    // 初始化CookieBot授权
    if (!this.customAuth) {
      try {
        // 存在自定义授权
        if (CookieInsAuth) {
          // 将自定义授权同步到Cookiebot并移除
          this.handleSubmitCustomConsent(
            CookieInsAuth?.preferences,
            CookieInsAuth?.statistics,
            CookieInsAuth?.marketing
          );
          cache.removeCookie('CookieConsentIns');
        }

        // 不存在自定义授权
        if (!CookieInsAuth) {
          // 用户未授权
          if (!CookieBotAuth) {
            if (this.CookieCountry.isGDPR || this.CookieCountry.isUS) {
              this.showBanner();
            } else {
              // console.log('用户未授权, 非GDPR, 默认同意所有');
              this.handleSubmitCustomConsent(true, true, true);
            }
          }

          // 用户已授权
          if (CookieBotAuth) {
            // 用户已授权，不需要做处理
            this.consent.preferences = CookieBotAuth.preferences;
            this.consent.statistics = CookieBotAuth.statistics;
            this.consent.marketing = CookieBotAuth.marketing;
            this.autoConsentByGPC();
          }
        }
      } catch (e) {
        console.error('初始化CookieConsentAuth失败', e);
      }
    }

    // 初始化自定义授权
    if (this.customAuth) {
      try {
        if (CookieInsAuth) {
          // 有自定义授权则以自定义授权为准
          this.consent.preferences = CookieInsAuth.preferences;
          this.consent.statistics = CookieInsAuth.statistics;
          this.consent.marketing = CookieInsAuth.marketing;
          this.autoConsentByGPC();
          this.handleLoadSnippets();
        }

        if (!CookieInsAuth && CookieBotAuth) {
          this.handleSubmitCustomConsent(CookieBotAuth.preferences, CookieBotAuth.statistics, CookieBotAuth.marketing);
        }

        if (!CookieInsAuth && !CookieBotAuth) {
          // 无自定义授权，无CookieBot授权，根据地区则初始化

          if (this.CookieCountry.isGDPR || this.CookieCountry.isUS) {
            this.showBanner();
          }
          if (!this.CookieCountry.isGDPR && !this.CookieCountry.isUS) {
            this.handleSubmitCustomConsent(true, true, true);
          }
        }
      } catch (e) {
        console.error('初始化CookieCustomConsentAuth失败', e);
      }
    }

    // 派发实例初始化完成
    // this.initEvent = new CustomEvent('CookieConsentInstanceInit');
    // window.dispatchEvent(this.initEvent);

    window.addEventListener('InstaUserActive', () => {
      this.handleLoadSnippets();
    });

    // 不显示banner的前提下展示弹窗
    if (!this.bannerVisible) this.showSubscribeModal();
  }

  showBanner() {
    if (!this.CookieBannerRef?.current) return;
    this.bannerVisible = true;
    this.CookieBannerRef.current.style.bottom = 0;
    // document.body.setAttribute('data-hideToolBar', true);
    GlobalTracker.CookieBot({
      action: 'cookie_banner_expose',
    });
  }

  hideBanner() {
    if (!this.CookieBannerRef?.current) return;
    this.bannerVisible = false;
    this.CookieBannerRef.current.style.bottom = '-1000%';
    // document.body.setAttribute('data-hideToolBar', false);

    // 显示订阅弹窗
    this.showSubscribeModal();
  }

  closeBanner() {
    // 关闭banner
    // - US - 无GPC，等同于同意;
    //      - 有GPC，拒绝 sharing personal information
    // - GDPR - 不同意也不拒绝，仅关闭
    const { isUS } = this.CookieCountry ?? {};
    switch (true) {
      case isUS:
        this.handleSubmitCustomConsent(true, true, true);
        break;
      default:
        break;
    }
    this.hideBanner();
    GlobalTracker.CookieBot({
      action: 'cookie_banner_close',
    });
  }

  allowBanner() {
    this.handleSubmitCustomConsent(true, true, true, true);
    this.hideBanner();
    GlobalTracker.CookieBot({
      action: 'cookie_banner_all',
    });
  }

  denyBanner() {
    this.handleSubmitCustomConsent(false, false, false);
    this.hideBanner();
    GlobalTracker.CookieBot({
      action: 'cookie_banner_deny',
    });
  }

  showDetailModal() {
    if (!this.DetailModalRef?.current) return;
    this.DetailModalRef.current?.showDetailModal();
    GlobalTracker.CookieBot({
      action: 'cookie_banner_setting',
    });
  }

  closeDetailModal() {
    if (!this.DetailModalRef?.current) return;
    this.DetailModalRef.current?.closeDetailModal();
  }

  showDNSModal() {
    if (!this.DNSModalRef?.current) return;
    this.DNSModalRef.current?.showModal();
  }

  // 显示订阅弹窗
  showSubscribeModal() {
    this.props.MobxApp.setGlobalModalState({ key: 'CookieBot', activated: true });
  }

  autoConsentByGPC() {
    if (this.complyGPC)
      this.handleSubmitCustomConsent(this.consent.preferences, this.consent.statistics, this.consent.marketing);
  }

  handleSubmitCustomConsent(preferences, statistics, marketing, ignoreGPC = false) {
    if (this.complyGPC && !ignoreGPC && navigator?.globalPrivacyControl) {
      statistics = false;
      marketing = false;
    }
    this.consent.preferences = preferences;
    this.consent.statistics = statistics;
    this.consent.marketing = marketing;

    if (this.customAuth) {
      cache.setCookie('CookieConsentIns', JSON.stringify(this.consent), { expires: this.CookieExpires });
      this.handleLoadSnippets();
    } else {
      if (!preferences && !statistics && !marketing) {
        this.Cookiebot.withdraw();
      } else {
        this.Cookiebot.submitCustomConsent(preferences, statistics, marketing);
      }
    }
  }

  /** 确定用户的cookie政策后，派发响应事件，需要关注cookie政策同意后进行的处理可关注 */
  dispatchCookieConsentComplete() {
    window.dispatchEvent(new CustomEvent('CookieConsentComplete', { detail: this.consent }));
  }

  handleAcceptListener() {
    const _this = this;
    window.addEventListener('CookiebotOnAccept', () => {
      // 同意/拒绝部分类型
      // console.log('同意/拒绝部分类型 CookiebotOnAccept');
      _this.handleLoadSnippets();
      _this.dispatchCookieConsentComplete();
    });

    window.addEventListener('CookiebotOnDecline', () => {
      // 拒绝非必要所有类型
      // console.log('拒绝非必要所有类型 CookiebotOnDecline');

      // 停止 Google 数据上报
      window['ga-disable-UA-79598165-15'] = true;
      window['ga-disable-UA-79598165-17'] = true;
      window['ga-disable-UA-79598165-18'] = true;
      window['ga-disable-UA-79598165-21'] = true;
      window['ga-disable-UA-79598165-22'] = true;
      window['ga-disable-G-46QD011RHK'] = true;
      window['ga-disable-G-1QXMD579SC'] = true;

      _this.dispatchCookieConsentComplete();

      // Mobx App 目标方法内阻止
      // FacebookPixel、TikTok、Twitter、BaiduAds

      // _Ecommerce Track 目标方法内阻止
      // A8Tag、Yahoo、Naver

      // Utils - linkedin_track
      // Linkedin
    });
  }

  handleLoadSnippets(forceLoad) {
    // console.log('CookiebotOnAccept preferences', this.consent.preferences);
    // console.log('CookiebotOnAccept statistics', this.consent.statistics);
    // console.log('CookiebotOnAccept marketing', this.consent.marketing);

    if (this.consent.preferences) this.loadSnippets(Category.preferences, forceLoad);
    if (this.consent.statistics) this.loadSnippets(Category.statistics, forceLoad);
    if (this.consent.marketing) this.loadSnippets(Category.marketing, forceLoad);
  }

  handleLocaleReplace(localeKey) {
    const LANG = this.props.LANG;
    const __PrivacyPolicy__ = `<a data-click-anchor="privacy-policy" href="${LANG['common.cookieConsent.btnPPUrl']}" target="_blank">${LANG['common.cookieConsent.btnPP']}</a>`;
    const __CookiePolicy__ = `<a data-click-anchor="cookie-policy" href="${LANG['common.cookieConsent.btnCPUrl']}" target="_blank">${LANG['common.cookieConsent.btnCP']}</a>`;
    const __CookieSetting__ = `<button id='cookieSettingTrigger'>${LANG['common.cookieConsent.btnCS']}</button>`;
    // const __CookieSettingUS__ = `<button id='cookieSettingTrigger'>${LANG['common.cookieConsent.btnDNS']}</button>`;
    const __CookieList__ = `<button id='cookieListAnchor'>${LANG['common.cookieConsent.btnCL']}</button>`;
    return LANG[localeKey]
      .replace(/__PrivacyPolicy__/g, __PrivacyPolicy__)
      .replace(/__CookiePolicy__/g, __CookiePolicy__)
      .replace(/__CookieSetting__/g, __CookieSetting__)
      .replace(/__CookieList__/g, __CookieList__);
  }

  initSnippets() {
    const { isOrderResultPage } = this.props.MobxApp;
    const group = [
      {
        name: 'Arms',
        category: [Category.preferences],
        loader: () => {
          ScriptSnippets.Arms({ country: this.InstaCountry });
        },
      },
      {
        name: 'FacebookPixel',
        category: [Category.marketing],
        loader: () => ScriptSnippets.FacebookPixel({ country: this.InstaCountry }),
      },
      {
        name: 'CrazyEgg',
        category: [Category.statistics],
        loader: () => {
          if (isOrderResultPage) return;
          ScriptSnippets.CrazyEgg({ country: this.InstaCountry });
        },
      },
      {
        name: 'Attentive',
        category: [Category.marketing],
        loader: () => {
          if (isOrderResultPage) return;
          ScriptSnippets.Attentive({ country: this.InstaCountry });
        },
      },
      {
        name: 'Bing',
        category: [Category.marketing],
        loader: () => ScriptSnippets.Bing({ country: this.InstaCountry }),
      },
      // {
      //   name: 'Linkedin',
      //   category: [Category.marketing],
      //   loader: () => ScriptSnippets.Linkedin({ country: this.InstaCountry }),
      // },
      {
        name: 'PushEngage',
        category: [Category.marketing],
        loader: () => {
          if (isOrderResultPage) return;
          ScriptSnippets.PushEngage({ country: this.InstaCountry });
        },
      },
      {
        name: 'Naver',
        category: [Category.marketing],
        loader: () => ScriptSnippets.Naver({ country: this.InstaCountry }),
      },
      {
        name: 'A8Tag',
        category: [Category.marketing],
        loader: () => ScriptSnippets.A8Tag({ country: this.InstaCountry }),
      },
      {
        name: 'Yahoo',
        category: [Category.marketing],
        loader: () => ScriptSnippets.Yahoo({ country: this.InstaCountry }),
      },
      {
        name: 'TikTok',
        category: [Category.marketing, Category.statistics],
        loader: () => ScriptSnippets.TikTok({ country: this.InstaCountry }),
      },
      {
        name: 'Twitter',
        category: [Category.marketing, Category.statistics],
        loader: () => ScriptSnippets.Twitter({ country: this.InstaCountry }),
      },
      {
        name: 'BaiduAds',
        category: [Category.marketing],
        loader: () => {
          ScriptSnippets.BaiduHM({ country: this.InstaCountry });
        },
      },
      {
        name: 'TTD',
        category: [Category.marketing],
        loader: () => {
          ScriptSnippets.TTD({ country: this.InstaCountry });
        },
      },
      {
        name: 'DataTester',
        category: [Category.statistics],
        loader: () => {
          ScriptSnippets.DataTester();
        },
      },
      {
        name: 'VWO',
        category: [Category.statistics],
        loader: () => {
          ScriptSnippets.VWO({ country: this.InstaCountry });
        },
      },
    ];
    return group;
  }

  canLoadSnippets(snippetName) {
    const snippet = this.SnippetsGroup.find((o) => o.name === snippetName);
    if (!snippet) return false;
    return snippet.category.find((c) => this.consent[c]);
  }

  loadSnippets(category, forceLoad) {
    const needLoadSnippetsList = this.SnippetsGroup.filter((o) => o.category.includes(category));
    const loadedMap = {};
    needLoadSnippetsList.forEach((o) => {
      if (!forceLoad && !window.InstaUserActive) return;
      if (loadedMap[o.name]) return;
      if (o.loader) {
        loadedMap[o.name] = true;
        o.loader();
      }
    });
  }

  // @deprecated
  dataCollectionTracker({ from = 'auto', action = '', label = '', clp = 0, cls = 0, clm = 0 }) {
    // const event = 'CookieBotTracker';

    const data = {
      from, // 来源，banner || modal弹窗 || auto 初始化 or 自动同意
      action, // accept 完全接受 || close 关闭 || declined 完全拒绝 || customSetting 接受部分 || showBanner 初始化展示banner || showModal
      label, // 备注
      clp: clp ? 1 : 0, // preferences分类: 1 同意 || 0 拒绝
      cls: cls ? 1 : 0, // statistics分类: 1 || 0
      clm: clm ? 1 : 0, // marketing分类: 1 || 0
      sid: this.props.MobxApp.handleSessionId({ action: 'get' }), // 会话id
      area: this.InstaCountry?.code?.toUpperCase(), // 当前商城地区码
      areaCb: this.Cookiebot?.userCountry?.toUpperCase(), // Cookiebot解析地区
    };

    if (data.action === 'accept') {
      data.clp = 1;
      data.cls = 1;
      data.clm = 1;
    }

    if (data.action === 'declined') {
      data.clp = 0;
      data.cls = 0;
      data.clm = 0;
    }

    // 暂停自定义采集
    // this.props.MobxAuth.dataCollect({ event, data });
  }
}

export default CookieConsent;
